import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import carInsuranceService from "../../../../api/CarInsurance/CarInsuranceService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default class UpdateCarInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvailableCarInsurances: [],
      selectedCarInsurance: {
        id: null,
        description: "",
        ar_description: "",
        email: "",
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllCarInsurances();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getAllCarInsurances = () => {
    this.setState({ allAvailableCarInsurances: [] });
    carInsuranceService
      .getAllInsurances()
      .then((res) => {
        res.data.map((insurance, i) => {
          console.log("category:", insurance);
          return this.setState({
            allAvailableCarInsurances: [
              ...this.state.allAvailableCarInsurances,
              {
                key: i + 1,
                id: insurance.id,
                description: insurance.description,
                ar_description: insurance.ar_description,
                email: insurance.email,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectCarInsurances = () => {
    return this.state.allAvailableCarInsurances?.map((insurance) => {
      return <option value={insurance.id}>{insurance.description}</option>;
    });
  };

  onSelectCarInsurance = (e) => {
    this.state.allAvailableCarInsurances.map(
      (insurance) =>
        e.target.value === insurance.id &&
        this.setState({
          selectedCarInsurance: {
            id: insurance.id,
            description: insurance.description,
            ar_description: insurance.ar_description,
            email: insurance.email,
          },
        })
    );
  };

  updateCarInsurance = () => {
    console.log("selected category", this.state.selectedCarInsurance);
    carInsuranceService.editInsurance(this.state.selectedCarInsurance.id, {
      description: this.state.selectedCarInsurance.description,
      ar_description: this.state.selectedCarInsurance.ar_description,
      email: this.state.selectedCarInsurance.email,
    });
    toast.success(`Car Insurance Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllCarInsurances();
  };

  onChangeCarInsuranceData = (e) => {
    let selectedCarInsurance = this.state.selectedCarInsurance;
    selectedCarInsurance[e.target.name] = e.target.value;
    this.setState({ selectedCarInsurance });
  };
  onChangeCarInsuranceDescriptionData = (name, value) => {
    let selectedCarInsurance = this.state.selectedCarInsurance;
    selectedCarInsurance[name] = value;
    this.setState({ selectedCarInsurance });
  };

  render() {
    let selectCarInsurances = this.selectCarInsurances();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Car Insurance</h5>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <div className="form-group mt-2" id="role">
              <select
                class="form-control"
                id="role"
                onChange={this.onSelectCarInsurance}
              >
                <option value="#">Select Car Insurance</option>
                {selectCarInsurances}
              </select>
            </div>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                id="description"
                name="description"
                defaultValue={this.state.selectedCarInsurance.description}
                onChange={this.onChangeCarInsuranceData}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data={
                  this.state.selectedCarInsurance.description
                    ? this.state.selectedCarInsurance.description
                    : "Waiting data to Load..."
                }
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onChangeCarInsuranceDescriptionData("description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Arabic Description</label>
              {/* <FormControl
                autoFocus
                type="text"
                id="description"
                name="description"
                defaultValue={this.state.selectedCarInsurance.description}
                onChange={this.onChangeCarInsuranceData}
              /> */}
              <CKEditor
                editor={ClassicEditor}
                data={
                  this.state.selectedCarInsurance.ar_description
                    ? this.state.selectedCarInsurance.ar_description
                    : "Waiting data to Load..."
                }
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onChangeCarInsuranceDescriptionData(
                    "ar_description",
                    data
                  );
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Email</label>
              <FormControl
                autoFocus
                type="text"
                id="email"
                name="email"
                defaultValue={this.state.selectedCarInsurance.email}
                onChange={this.onChangeCarInsuranceData}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateCarInsurance}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
